import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CpslButton, CpslIcon } from '@usecapsule/react-components';
import { Heading, HeroNoSpacing, SecondaryText, ButtonWithIconContainer, AddFundsButton } from '../common.js';
import { styled } from 'styled-components';
export const TwoFactorDoneStep = ({ onClose }) => {
    return (_jsxs(_Fragment, { children: [_jsx(HeroNoSpacing, { icon: "heroWallet" }), _jsx(Heading, { children: _jsx("span", { children: "Success" }) }), _jsx(SecondaryText, { children: "Your Two-Factor Authentication has been successfully set up!" }), _jsx(CpslButton, { fullWidth: true, onClick: onClose, children: _jsxs(ButtonWithIconContainer, { children: [_jsx(CheckIcon, { icon: "check" }), "Done"] }) }), _jsx(AddFundsButton, {})] }));
};
const CheckIcon = styled(CpslIcon) `
  --width: 20px;
  --height: 20px;
`;
